module.exports = __webpack_public_path__ + "img/briefcase.f07daff2.svg";